<script>

	import t from '../../translations/translator.js';
	import Account from './Account.svelte';
    import AddGame from './AddGame.svelte';
	import AddGameInfo from './AddGameInfo.svelte';
	import AddApp from './AddApp.svelte';
	import Billing from './Billing.svelte';
    import Inbox from './Inbox.svelte';
	import UserGameSettings from './UserGameSettings.svelte';
	import UserGamesOverview from './UserGamesOverview.svelte';
	import { onMount } from 'svelte';
    import { Sections } from '../../lib/nav.js';
	import { getGame } from '../stores/GameStore.js';

	let games = [];
	let apps = [];

	async function reloadGames() {
		try {

			const csrfToken = localStorage.getItem("csrfToken");
			const response = await fetch('https://www.deckblox.app/rest/gamelist', {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'X-CSRF-Token': csrfToken,
				}
			});
			console.log('Retrieved games (???):', response);
			const data = await response.json();
			games = data;
			console.log('Retrieved games (ok):', games);
		} catch (err) {
			console.error('Retrieved games (fail)', err);
		}
	}

	//let currentFragment = 'general';
	let selectedGameId = -1;
	let selectedUserGameId = -1;
	let selectedUserAppId = -1;

	let currentSection = Sections.GENERAL_ACCOUNT;

	let isAuthenticated = false;

	function handleLogin() {
		isAuthenticated = true;
	}

	function handleLogout() {
		isAuthenticated = false;
	}

	function handleGameSelected(id) {
		selectedGameId = id;
		currentFragment = 'gameInfo'; // Or whatever fragment you want
	}

	function handleGameInfoBack() {
		selectedGameId = -1;
		currentFragment = 'addNewGame';
	}

	function handleNavigation(section, params) {
		console.log("Navigate to:", section, params);
		currentSection = section;
		if(params) {
			if(params.newUserGameId) {
				selectedUserGameId = params.newUserGameId;
				reloadGames();
			}
			if(params.selectedGameId) {
				selectedGameId = params.selectedGameId;
			}
			if(params.selectedUserGameId) {
				selectedUserGameId = params.selectedUserGameId;
			}
			if(params.requireMenuRefresh) {
				reloadGames();
			}
		}
	}

	function openGameSettings(id) {
		selectedUserGameId = id;
		currentFragment = 'userGameSettings';
	}

	function openAppSettings(id) {
		selectedUserAppId = id;
		currentFragment = 'userAppSettings';
	}

	onMount(reloadGames);

</script>


  <div class="flex h-screen">

	<!-- Left Menu -->
	<nav class="w-64 bg-[var(--app-background-level-1)] text-[var(--app-text-color)] leftmenu">
	  <ul>
		<li>
		  <div class="p-4 cursor-default text-[var(--app-title-color-darker)]">{t("MenuTitleGeneral")}</div>
		  <ul class="ml-4">
			<li class="p-2 cursor-pointer" on:click={() => handleNavigation(Sections.GENERAL_ACCOUNT)}>{t("MenuGeneralAccount")}</li>
			<li class="p-2 cursor-pointer" on:click={() => handleNavigation(Sections.GENERAL_SUBSCRIPTION)}>{t("MenuGeneralSubscription")}</li>
			<li class="p-2 cursor-pointer" on:click={() => handleNavigation(Sections.GENERAL_INBOX)}>{t("MenuGeneralInbox")}</li>
			<!--<li class="p-2 cursor-pointer" on:click={() => navigateTo('statistics')}>{t("MenuGeneralStatistics")}</li>-->
		  </ul>
		</li>
		<li>
			<div class="p-4 flex justify-between items-center cursor-default text-[var(--app-title-color-darker)]">
				<span>{t("MenuTitleGames")}</span>
				<div class="flex space-x-2">
					<button
					class="w-6 h-6 flex items-center justify-center text-white hover:bg-gray-700 rounded focus:outline-none"
					title={t("MenuGamesOverview_Tooltip")}
					on:click={(e) => { e.stopPropagation(); handleNavigation(Sections.GAMES_OVERVIEW); }}>
					<img src="/icons/icon_list_64.png" alt="Overview" class="w-4 h-4" />
					</button>

					<button
					class="w-6 h-6 flex items-center justify-center text-white hover:bg-gray-700 rounded focus:outline-none"
					title={t("MenuGamesAddNew_Tooltip")}
					on:click={(e) => { e.stopPropagation(); handleNavigation(Sections.GAMES_ADD_NEW); }}>
					<img src="/icons/icon_plus_64.png" alt="Add" class="w-4 h-4" />
					</button>
				</div>
			</div>


		  <ul class="ml-4">
			{#if games.length > 0}
				{#each games as game}
					<!--<li class="p-2 cursor-pointer" on:click={() => handleNavigation(Sections.GAMES_SETTINGS, {selectedUserGameId: game.id})}>
						{game.title || t("MenuUntitledGamePlaceholder")} ({game.id})
					</li>-->
					<!-- svelte-ignore a11y-click-events-have-key-events -->
					<li class="p-2 cursor-pointer flex items-center gap-2"
						on:click={() => handleNavigation(Sections.GAMES_SETTINGS, { selectedUserGameId: game.id })}>
						<img src={getGame(game.gameId).image} alt="" class="w-8 h-8 rounded" />
						<span>{game.title || t("MenuUntitledGamePlaceholder")}</span>
					</li>
				{/each}
			{:else}
				<li class="p-2 italic text-gray-400 cursor-default">{t("MenuNoGamesPlaceholder")}</li>
			{/if}
		  </ul>
		</li>
		<li>
			<div class="p-4 flex justify-between items-center cursor-default text-[var(--app-title-color-darker)]">
				<span>{t("MenuTitleApps")}</span>
				<div class="flex space-x-2">
					<button
					class="w-6 h-6 flex items-center justify-center text-white hover:bg-gray-700 rounded focus:outline-none"
					title={t("MenuAppsOverview_Tooltip")}
					on:click={(e) => { e.stopPropagation(); handleNavigation(Sections.APPS_OVERVIEW); }}>
					<img src="/icons/icon_list_64.png" alt="Overview" class="w-4 h-4" />
					</button>

					<button
					class="w-6 h-6 flex items-center justify-center text-white hover:bg-gray-700 rounded focus:outline-none"
					title={t("MenuAppsAddNew_Tooltip")}
					on:click={(e) => { e.stopPropagation(); handleNavigation(Sections.APPS_ADD_NEW); }}>
					<img src="/icons/icon_plus_64.png" alt="Add" class="w-4 h-4" />
					</button>
				</div>
			</div>
		  <ul class="ml-4">
			{#if apps.length > 0}
				{#each apps as app}
					<li class="p-2 cursor-pointer" on:click={() => openAppSettings(app.appId)}>{app.title}</li>
				{/each}
			{:else}
				<li class="p-2 italic text-gray-400 cursor-default">{t("MenuNoAppsPlaceholder")}</li>
			{/if}
		  </ul>
		</li>
	  </ul>
	</nav>
  
	<!-- Main Content -->
	<main class="flex-1 p-6 text-[var(--app-text-color)]">

		{#if currentSection === Sections.GENERAL_ACCOUNT}
			<Account />
		{:else if currentSection === Sections.GENERAL_SUBSCRIPTION}
			<Billing />
		{:else if currentSection === Sections.GENERAL_INBOX}
			<Inbox />
		{:else if currentSection === Sections.GAMES_ADD_NEW}
			<AddGame onGameSelected={handleNavigation} />
		{:else if currentSection === Sections.APPS_ADD_NEW}
			<AddApp />
		{:else if currentSection === Sections.GAMES_ADD_NEW_DETAILS}
			<AddGameInfo id={selectedGameId} onNavigate={handleNavigation} />
		{:else if currentSection === Sections.GAMES_SETTINGS}
			{#key selectedUserGameId}
				<UserGameSettings id={selectedUserGameId} onNavigate={handleNavigation} />
			{/key}
		{:else if currentSection === Sections.GAMES_OVERVIEW}
			<UserGamesOverview onNavigate={handleNavigation} games={games} />
		
		{:else}
			<div class="">
				<h1 class="text-2xl font-semibold mb-4 section-title border-b-[0.66px] border-gray-400 pb-2 text-left">
					{`Unknown Page`}
				</h1>

				<p class="text-gray-300">Currently viewing: {currentSection}</p>

			</div>
		{/if}

		
	  </main>
  </div>